const EARTH_RADIUS_M = 6371000;
export const NEARBY_CITY_LIMIT_METERS = 60 * 1000;

export const distanceMeters = (a, b) => {
  if (!a || !b) return null;
  const toRadians = (degree) => (degree * Math.PI) / 180;
  const dLat = toRadians(b.lat - a.lat);
  const dLng = toRadians(b.lng - a.lng);
  const lat1 = toRadians(a.lat);
  const lat2 = toRadians(b.lat);
  const h =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) ** 2;
  return 2 * EARTH_RADIUS_M * Math.asin(Math.min(1, Math.sqrt(h)));
};

export const nearestCityToPoint = (cities, point) => {
  if (!point) return null;
  let nearest = null;
  for (const city of cities) {
    const center = city.center;
    if (center?.lat == null || center?.lng == null) continue;
    const meters = distanceMeters(point, center);
    if (!nearest || meters < nearest.distanceMeters) {
      nearest = { ...city, distanceMeters: meters };
    }
  }
  return nearest;
};

export const nearbyCityToPoint = (cities, point, limit = NEARBY_CITY_LIMIT_METERS) => {
  const nearest = nearestCityToPoint(cities, point);
  return nearest && nearest.distanceMeters <= limit ? nearest : null;
};
